import React from "react";

const OrganizeIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.649"
      height="21.602"
      viewBox="0 0 24.649 21.602"
    >
      <g id="db4" transform="translate(-6.5 -10)">
        <path
          id="Path_1152"
          data-name="Path 1152"
          d="M30.318,25.786h-1.44V21.6a.816.816,0,0,0-.831-.831H19.6V16.647h1.717a.816.816,0,0,0,.831-.831V10.831A.816.816,0,0,0,21.317,10H16.332a.816.816,0,0,0-.831.831v4.985a.816.816,0,0,0,.831.831h1.606v4.127H9.6a.816.816,0,0,0-.831.831v4.182H7.331a.816.816,0,0,0-.831.831v4.154a.816.816,0,0,0,.831.831h4.431a.816.816,0,0,0,.831-.831V26.617a.816.816,0,0,0-.831-.831H10.433V22.435h7.505v3.351H16.609a.816.816,0,0,0-.831.831v4.154a.816.816,0,0,0,.831.831H21.04a.816.816,0,0,0,.831-.831V26.617a.816.816,0,0,0-.831-.831H19.6V22.435h7.616v3.351H25.61a.816.816,0,0,0-.831.831v4.154a.816.816,0,0,0,.831.831h4.708a.816.816,0,0,0,.831-.831V26.617A.816.816,0,0,0,30.318,25.786Z"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default OrganizeIcon;
